import { useContext, useEffect, useState } from "react";
import Layout from "../../Component/layout/main-layout";
import { GetConstitutionTable } from "../../api/Queries/get";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/loader/loader";
import { Context } from "../../Store/context";
import layoutBgImg from "../../Images/layout/laws.png";

const ConstitutionTable = () => {
  const location = useLocation().pathname.split("/")[2];
  const [constitution, setConstitution] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { i18n, t } = useTranslation();
  const { showError } = useContext(Context);

  useEffect(() => {
    const getConstitution = async () => {
      setIsLoading(true);

      try {
        const res = await GetConstitutionTable(location);
        setConstitution(res?.data || null);
      } catch (error) {
        showError(error?.message);
      } finally {
        setIsLoading(false);
      }
    };

    if (location) {
      getConstitution();
    }
  }, [location, showError]);

  const getLawPdf = (laws) => {
    if (!laws) return "";
    const currentLang = i18n.language;
    if (currentLang === "ru") {
      return laws.rus_pdf || laws.tm_pdf || "";
    }
    if (currentLang === "en") {
      return laws.eng_pdf || laws.tm_pdf || "";
    }
    return laws.tm_pdf || "";
  };

  const pdf = getLawPdf(constitution);

  return (
    <div className="mb-20">
      <Layout
        title={t("laws_codes")}
        page={t("tm_constitution")}
        layoutBgImg={layoutBgImg}
      />

      <main className="media">
        <div
          className="border border-secondary bg-white mt-8
                     dark:border-dark-border p-8 w-full
                     dark:bg-dark-box dark:text-dark-text"
        >
          {isLoading ? (
            <Loading />
          ) : pdf ? (
            <div className="h-[1000px] max-h-max">
              <iframe
                src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                className="w-full h-full"
                frameBorder="0"
                title="PDF Viewer"
              />
            </div>
          ) : (
            <p className="text-center">PDF tapylmady</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default ConstitutionTable;